import {
  DB_TEMPLATES,
  DB_TEMPLATE_ID,
  DB_DEFAULT_TEMPLATE,
  DB_QUICKVIEW_TEMPLATE,
  SELECTED_SCORE,
  SELECTED_SCORE_BAR,
  SELECTED_SCORE_LINE,
} from "constants/ActionTypes"

const INIT_STATE = {
  db_templates: [],
  db_template_id: null,
  db_default_template: null,
  db_quickview_template: null,
  survey_selected_score: [],
  survey_selected_score_bar: [],
  survey_selected_score_line: [],
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case DB_TEMPLATES: {
      return {
        ...state,
        db_templates: action.payload.templates
      }
    }

    case DB_TEMPLATE_ID: {
      return {
        ...state,
        db_template_id: action.payload.db_template_id
      }
    }

    case DB_DEFAULT_TEMPLATE: {
      return {
        ...state,
        db_default_template: action.payload.template
      }
    }

    case DB_QUICKVIEW_TEMPLATE: {
      return {
        ...state,
        db_quickview_template: action.payload.template
      }
    }

    case SELECTED_SCORE: {
      return {
        ...state,
        survey_selected_score: action.payload.score
      }
    }

    case SELECTED_SCORE_BAR: {
      return {
        ...state,
        survey_selected_score_bar: action.payload.score
      }
    }

    case SELECTED_SCORE_LINE: {
      return {
        ...state,
        survey_selected_score_line: action.payload.score
      }
    }

    default:
      return state;
  }
}